<template>
  <div :class="['inputswitch', isChecked && 'border-primary bg-primary']">
    <input v-model="isChecked" type="checkbox" role="switch" :aria-checked="isChecked" :aria-label="ariaLabel" />
    <span class="inputswitch-slider"></span>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, computed } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: Boolean,
  ariaLabel: String
});

const isChecked = computed({
  get: () => props.modelValue,
  set: v => emit('update:modelValue', v)
});
</script>

<style scoped>
.inputswitch {
  position: relative;
  box-sizing: content-box;
  display: inline-block;
  height: 1rem;
  width: 2rem;
  padding: 2px;
  border-radius: 30px;
  transition: 200ms;
  cursor: pointer;
  background-color: #e5e5ea;
  border-color: #e5e5ea;
}

.inputswitch input[type="checkbox"] {
  appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  z-index: 1;
  outline: 0 none;
  border-radius: 30px;
  cursor: pointer;
}

.inputswitch-slider {
  position: absolute;
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  transition: 200ms;
  background-color: #fff;
  transform: translateX(1px);
}

.inputswitch.bg-primary>.inputswitch-slider {
  transform: translateX(100%);
}
</style>